import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputSearch } from '@/pcomponents/common/date_picker/custom_input';
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";
import DatePicker from "react-datepicker";

function SearchArea(props: any) {
  let myProps = {
    listOpt: {
      "s_year": DateFunc.get_date_format(new Date(), "Y"),
      's_date_type': 'a_date',
      's_start_date': DateFunc.get_date_format(new Date(), "Y-m-01"),
      's_end_date': DateFunc.get_date_format(new Date(), "Y-m-t"),
    },
    list: (inData: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;

  const on_change_search_input=(inData:any)=>{
    let { name, value } = inData.target;
    let change_list_opt:any={};
    change_list_opt[name]=value;
    myProps.list({
      now_page:"1",
      ...change_list_opt
    });
  };

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");

    let date_list_opt: any = {
      now_page: "1",
      ...{ [key]: date_str }
    };
    if (key == "s_start_date") {
      date_list_opt["s_year"] = date_str.substring(0, 4);
    }

    myProps.list(date_list_opt);
  };

  const goChangeDateMonth = (month: number) => {
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let row_year = selected_date.substring(0, 4);
    let row_month = strFunc.str_pad({ "str": month, "pad_length": 2 });
    selected_date = row_year + "-" + row_month + "-01";

    let start_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-01");
    let end_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-t");

    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  const goDateMonthChange = (sort: any) => {
    //next,pre
    let selected_date = myProps.listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let change_date_obj = new Date(selected_date);
    if (sort == "pre") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', -1);
    } else if (sort == "next") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', +1);
    }

    let start_date = DateFunc.get_date_format(change_date_obj, "Y-m-01");
    let end_date = DateFunc.get_date_format(change_date_obj, "Y-m-t");
    myProps.list({
      now_page: "1",
      ...{
        s_year: start_date.substring(0, 4),
        s_start_date: start_date,
        s_end_date: end_date,
      }
    });
  };

  let year_month_num_arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div className="btn-box-left relative">
      <span className="text-blue-700">
        {listOpt.s_start_date.substring(5, 7)} 월
      </span>
      {year_month_num_arr.map((row_num) => {
        let btn_class_name = "btn btn-dark ml-1";
        let select_month_num = parseInt(listOpt.s_start_date.substring(5, 7));
        if (select_month_num == row_num) {
          btn_class_name = "btn btn-blue ml-1";
        }
        return (
          <button key={row_num} className={btn_class_name}
            onClick={() => { goChangeDateMonth(row_num); }} >{row_num}</button>
        );
      })}
      <span className="px-2">
        <button className="btn-s btn-dark" onClick={() => { goDateMonthChange("pre"); }} >◀</button>
        <button className="btn-s btn-dark ml-1" onClick={() => { goDateMonthChange("next"); }} >▶</button>
      </span>
      <span style={{ width: 100, display: "inline-block", marginLeft: 5 }}>
        <DatePicker
          selected={myProps.listOpt.s_start_date != "" ? new Date(myProps.listOpt.s_start_date) : null}
          onChange={(date: Date) => {
            onChangeDatePicker("s_start_date", date);
          }}
          locale={ko}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInputSearch />}
          renderCustomHeader={customHeaderFunc}
        />
      </span>~
      <span style={{ width: 100, display: "inline-block" }}>
        <DatePicker
          selected={myProps.listOpt.s_end_date != "" ? new Date(myProps.listOpt.s_end_date) : null}
          onChange={(date: Date) => {
            onChangeDatePicker("s_end_date", date);
          }}
          locale={ko}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInputSearch />}
          renderCustomHeader={customHeaderFunc}
        />
      </span>
      <input type="text" className='search-input' name="s_memo_like" 
        value={listOpt.s_memo_like} onChange={on_change_search_input} 
        style={{width:"80px"}}/>
      <button className='btn btn-dark' onClick={()=>{myProps.list({now_page:1});}} >검색</button>
    </div>
  );
};
export default SearchArea;